import { PROJECTS_CONFIG, GLOBAL_TOKENS } from "../config/projectsConfig";
import Environment from "./Environment";

/**
 * AUTO-GENERATED TOKENS AND PROJECT CONFIGURATIONS
 * This file is automatically populated from projectsConfig.js
 * DO NOT manually add projects here - update projectsConfig.js instead
 */

// Token configuration
export const TOKENS = [
    // { NAME: "GEMS", tokenImg: "gems", tokenAddress: GLOBAL_TOKENS.gems, decimals: 18 },
    { NAME: "ETH", tokenImg: "eth", tokenAddress: GLOBAL_TOKENS.eth, decimals: 18 },
    { NAME: "USDT", tokenImg: "usdt", tokenAddress: GLOBAL_TOKENS.busd, decimals: 6 },
    { NAME: "USDC", tokenImg: "usdc", tokenAddress: GLOBAL_TOKENS.usdc, decimals: 6 },
    // { NAME: "TOMI", tokenImg: "tomi", tokenAddress: GLOBAL_TOKENS.tomi, decimals: 18 },
    // { NAME: "WBTC", tokenImg: "wbtc", tokenAddress: GLOBAL_TOKENS.wbtc, decimals: 8 },
    // { NAME: "LINK", tokenImg: "link", tokenAddress: GLOBAL_TOKENS.link, decimals: 18 },
    // { NAME: "PEPE", tokenImg: "pepe", tokenAddress: GLOBAL_TOKENS.pepe, decimals: 18 },
    // { NAME: "UNI", tokenImg: "uni", tokenAddress: GLOBAL_TOKENS.uni, decimals: 18 },
    // { NAME: "DOP", tokenImg: "dop", tokenAddress: GLOBAL_TOKENS.dop, decimals: 18 },
];

export const tokens = [
    "ETH",
    "USDT",
    // "DOP",
    // "WBTC",
    // "GEMS",
    // "TOMI",
    "USDC",
    // "PEPE",
    // "UNI",
    // "LINK",
];

// Auto-generate project configurations from PROJECTS_CONFIG
export const projectConfigurations = PROJECTS_CONFIG?.map((project) => ({
    id: project.id,
    name: project.name,
    shortName: project.shortName,
    imageSrc: project.imageSrc,
    privateSale: project.id, // Uses the same ID for privateSale
    refLink: project.refLink || "",
    enabled: project.enabled, // Default to true if not specified
}));
// import Environment from "./Environment";

// export const TOKENS = [
//     { NAME: "GEMS", tokenImg: "gems", tokenAddress: Environment.gems, decimals: 18 },
//     { NAME: "ETH", tokenImg: "eth", tokenAddress: Environment.eth, decimals: 18 },
//     { NAME: "USDT", tokenImg: "usdt", tokenAddress: Environment.busd, decimals: 6 },
//     { NAME: "USDC", tokenImg: "usdc", tokenAddress: Environment.usdc, decimals: 6 },
//     { NAME: "TOMI", tokenImg: "tomi", tokenAddress: Environment.tomi, decimals: 18 }, // Could not reliably determine decimals
//     { NAME: "WBTC", tokenImg: "wbtc", tokenAddress: Environment.wbtc, decimals: 8 },
//     { NAME: "LINK", tokenImg: "link", tokenAddress: Environment.link, decimals: 18 },
//     { NAME: "PEPE", tokenImg: "pepe", tokenAddress: Environment.pepe, decimals: 18 },
//     { NAME: "UNI", tokenImg: "uni", tokenAddress: Environment.uni, decimals: 18 },
//     { NAME: "DOP", tokenImg: "dop", tokenAddress: Environment.dop, decimals: 18 },
// ];
//  export const tokens = [
//     "ETH",
//     "USDT",
//     "DOP",
//     "WBTC",
//     "GEMS",
//     "TOMI",
//     "USDC",
//     "PEPE",
//     "UNI",
//     "LINK",
//   ];
// export const projectConfigurations = [
//     {
//         id: "XPROTOCOL",
//         name: "Xprotocol",
//         shortName: "Xprotocol",
//         imageSrc: "	https://gems.vip/assets/alldetailpages/xprotocol/main-img.png",
//         privateSale: "XPROTOCOL"
//     },
//     {
//         id: "TIGA",
//         name: "Tiga",
//         shortName: "Tiga",
//         imageSrc: "https://gems.vip/assets/alldetailpages/tiga/main-img.png",
//         privateSale: "TIGA"
//     },
//     {
//         id: "CHAINERS",
//         name: "Chainers",
//         shortName: "Chainers",
//         imageSrc: "https://gems.vip/assets/alldetailpages/chainers/main-img.png",
//         privateSale: "CHAINERS"
//     },
//     {
//         id: "SCREX",
//         name: "Screx",
//         shortName: "Screx",
//         imageSrc: "https://gems.vip/assets/alldetailpages/screx/screxlogo.svg",
//         privateSale: "SCREX"
//     },
//     {
//         id: "LUCKIFY",
//         name: "Luckify",
//         shortName: "Luckify",
//         imageSrc: "/assets/luckify.svg",
//         privateSale: "LUCKIFY"
//     },
//     {
//         id: "MATCHAIN",
//         name: "Matchain",
//         shortName: "Matchain",
//         imageSrc: "/assets/matchain.svg",
//         privateSale: "MATCHAIN"
//     },
//     {
//         id: "RAIN",
//         name: "Rain",
//         shortName: "Rain",
//         imageSrc: "/assets/rain.svg",
//         privateSale: "RAIN"
//     },
//     {
//         id: "ASTRANOVA",
//         name: "Astra Nova",
//         shortName: "Astra Nova",
//         imageSrc: "/assets/astronova.svg",
//         privateSale: "ASTRANOVA"
//     },
//     {
//         id: "NFA",
//         name: "NFA",
//         shortName: "NFA",
//         imageSrc: "/assets/nfa.svg",
//         privateSale: "NFA"
//     },
//     {
//         id: "LEIA",
//         name: "LEIA",
//         shortName: "LEIA",
//         imageSrc: "/assets/leia-icon.svg",
//         privateSale: "LEIA"
//     },
//     {
//         id: "OLYMPUS",
//         name: "OLYMPUS",
//         shortName: "OLYMPUS",
//         imageSrc: "/assets/olympus.png",
//         privateSale: "OLYMPUS"
//     },
//     {
//         id: "INCENTIV",
//         name: "INCENTIV",
//         shortName: "INC",
//         imageSrc: "/assets/incetive-card-logo.png",
//         privateSale: "INCENTIV"
//     },
//     {
//         id: "GEMS",
//         name: "GEMS",
//         shortName: "GEMS",
//         imageSrc: "/assets/gemslogo.png",
//         privateSale: "GEMS"
//     },
//     {
//         id: "DOP",
//         name: "DOP",
//         shortName: "DOP",
//         imageSrc: "/assets/dashboardassets/ongoingcardone.svg",
//         privateSale: "DOP"
//     }
// ];